import React, { FC, useEffect, useState } from "react";
import { Puzzle } from "../models/puzzle";
import classes from "./ClueList.module.scss";
import {
  Button,
  DialogContent,
  List,
  ListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Lightbulb } from "@mui/icons-material";
import { DraggableWindow } from "../_shared/DraggableWindow";
import { BrandModal } from "../_shared/BrandModal";

export type ClueListProps = {
  puzzle?: Puzzle;
  tutorialShowing?: boolean;
};

export const ClueList: FC<ClueListProps> = ({ puzzle, tutorialShowing }) => {
  const isWide = useMediaQuery("(min-width:1024px)");
  const [showClues, setShowClues] = useState(false);

  useEffect(() => {
    const today = new Date();
    const datestamp = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
    // Auto-pop the modal on narrow screens (where there's no persistent panel)
    if (
      !tutorialShowing &&
      !isWide &&
      localStorage.getItem("tutorial") &&
      !localStorage.getItem(`clues-${datestamp}`)
    ) {
      localStorage.setItem(`clues-${datestamp}`, "true");
      setShowClues(true);
    }
  }, [tutorialShowing, isWide]);

  if (isWide) {
    return (
      <DraggableWindow title="CLUES" className={classes.cluePanel}>
        <ul className={classes.cluePanelList}>
          {puzzle?.clues?.map((x) => (
            <li key={x[1].clue} className={classes.cluePanelItem}>
              <span className={classes.cluePanelNumber}>
                #{x[0]} {x[1].direction}
              </span>
              : {x[1].clue}
            </li>
          ))}
        </ul>
      </DraggableWindow>
    );
  }

  return (
    <>
      <Button
        color={"primary"}
        sx={{ width: 240 }}
        variant="contained"
        disableElevation
        className={classes.clueButton}
        onClick={() => setShowClues(true)}
        startIcon={
          <Lightbulb
            sx={(theme) => ({ color: theme.palette.background.default })}
          />
        }
      >
        Today's Clues
      </Button>
      <BrandModal
        open={showClues}
        onClose={() => setShowClues(false)}
        title="CLUES"
        maxWidth="xs"
      >
        <DialogContent>
          <List>
            {puzzle?.clues?.map((x) => (
              <ListItem key={x[1].clue}>
                <Typography>
                  <Typography component="span" display="inline" fontWeight="bold" color="primary">
                    #{x[0]} {x[1].direction}
                  </Typography>
                  : {x[1].clue}
                </Typography>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </BrandModal>
    </>
  );
};
